import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/MANAGE_PLAN';

export const {action: showCreatePlan} = createAction(`${domain}/SHOW_CREATE`, obj => ({
    institutionId: obj.institutionId,
    behaviors: obj.behaviors,
    childId: obj.childId,
    pricingGroupId: obj.pricingGroupId,
    editPlan: obj.editPlan,
    planUsedSessions: obj.planUsedSessions,
    planUsedProducts: obj.planUsedProducts,
    validOnMustBeBefore: obj.validOnMustBeBefore,
    validOnMustBeAfter: obj.validOnMustBeAfter,
    validToMustBeBefore: obj.validToMustBeBefore,
    validToMustBeAfter: obj.validToMustBeAfter,
    validTo: obj.validTo,
    canEditValidOn: obj.canEditValidOn,
    canEditValidTo: obj.canEditValidTo,
    trackingContext: obj.trackingContext,
    overrideSavePlan: obj.overrideSavePlan,
    overrideSaveText: obj.overrideSaveText,
    templateMode: obj.templateMode,
}));

export const {action: insertPlan} = createAction(`${domain}/INSERT`, obj => ({
    institutionId: obj.institutionId,
    childId: obj.childId,
    editPlan: obj.editPlan,
    planUsedSessions: obj.planUsedSessions,
    planUsedProducts: obj.planUsedProducts,
    canEditValidOn: obj.canEditValidOn,
    canEditValidTo: obj.canEditValidTo,
    validOnMustBeBefore: obj.validOnMustBeBefore,
    validOnMustBeAfter: obj.validOnMustBeAfter,
    validToMustBeBefore: obj.validToMustBeBefore,
    validToMustBeAfter: obj.validToMustBeAfter,
    trackingContext: 'INSERT_PLAN',
}));

export const {action: showEditPlan} = createAction(`${domain}/SHOW_EDIT_PLAN`, obj => ({
    institutionId: obj.institutionId,
    childId: obj.childId,
    editPlan: obj.editPlan,
    planUsedSessions: obj.planUsedSessions,
    planUsedProducts: obj.planUsedProducts,
    canEditValidOn: obj.canEditValidOn,
    canEditValidTo: obj.canEditValidTo,
    validOnMustBeBefore: obj.validOnMustBeBefore,
    validOnMustBeAfter: obj.validOnMustBeAfter,
    validToMustBeBefore: obj.validToMustBeBefore,
    validToMustBeAfter: obj.validToMustBeAfter,
    trackingContext: 'EDIT_PLAN',
    overrideSavePlan: obj.overrideSavePlan,
    overrideSaveText: obj.overrideSaveText,
    templateMode: obj.templateMode,
}));

export const {action: simpleViewPlan} = createAction(`${domain}/SIMPLE_VIEW_PLAN`, obj => ({
    institutionId: obj.institutionId,
    childId: obj.childId,
    editPlan: obj.editPlan,
    planUsedSessions: obj.planUsedSessions,
    planUsedProducts: obj.planUsedProducts,
    isEdit: obj.isEdit,
    overrideSavePlan: obj.overrideSavePlan,
}));

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const {action: closeManagePlan} = createAction(`${domain}/CLOSE`, () => {});

export const {action: updateToLaterPriceChange} = createAction(`${domain}/UPDATE_TO_LATER_PRICE_CHANGE`, validFrom => ({
    validFrom,
}));

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const {action: manuallyCloseModal} = createAction(`${domain}/MANUALLY_CLOSE_MODAL`, () => {});

export const {action: showEdit} = createAction(`${domain}/SHOW_EDIT`, show => ({show}));

export const {action: updateNote} = createAction(`${domain}/UPDATE_NOTE`, value => ({value}));

export const {action: addPlanPart} = createAction(`${domain}/ADD_PLAN_PART`, () => ({}));

export const {action: removePlanPart} = createAction(`${domain}/REMOVE_PLAN_PART`, planPartId => ({planPartId}));

export const {action: removeBooking} = createAction(`${domain}/REMOVE_BOOKING`, (planPartId, bookingId, session) => ({
    planPartId,
    bookingId,
    session,
}));

export const {action: removeProductBooking} = createAction(
    `${domain}/REMOVE_PRODUCT_BOOKING`,
    (planPartId, productBookingId, day) => {
        return {
            planPartId,
            productBookingId,
            day,
        };
    },
);

export const {action: removeAllBookings} = createAction(`${domain}/REMOVE_ALL_BOOKINGS`, planPartId => ({
    planPartId,
}));

export const {action: toggleFundable} = createAction(`${domain}/TOGGLE_FUNDING`, (planPartId, bookingId, fundable) => ({
    planPartId,
    bookingId,
    fundable,
}));

export const {action: startFetchingData} = createAction(`${domain}/START_FETCHING_DATA`, () => ({}));

export const {
    action: fetchManagePlanData,
    success: fetchManagePlanDataSuccess,
    failed: fetchManagePlanDataFailed,
} = createAction(
    `${domain}/FETCH_DATA`,
    (institutionId, pricingGroupId, validOn, validTo, billingProfileIds) => ({
        institutionId,
        pricingGroupId,
        validOn,
        validTo,
        billingProfileIds,
    }),
    (sessions, pricingGroups, pricingGroupBehaviors, billingProfiles, attendanceSchedules) => ({
        sessions,
        pricingGroups,
        pricingGroupBehaviors,
        billingProfiles,
        attendanceSchedules,
    }),
);

export const {action: startPreviewPlan} = createAction(`${domain}/START_PREVIEW`);

export const {
    action: previewPlan,
    success: previewPlanSuccess,
    failed: previewPlanFailed,
    aborted: previewPlanAborted,
} = createAction(
    `${domain}/PREVIEW`,
    () => ({}),
    plan => ({plan}),
);

export const {
    action: previewPlanPublicFunding,
    success: previewPlanPublicFundingSuccess,
    failed: previewPlanPublicFundingFailed,
    aborted: previewPlanPublicFundingAborted,
} = createAction(
    `${domain}/PREVIEW_PLAN_PUBLIC_FUNDING`,
    () => ({}),
    plan => ({plan}),
);

export const {
    action: createPlan,
    success: createPlanSuccess,
    failed: createPlanFailed,
} = createAction(
    `${domain}/CREATE_PLAN`,
    (plan, institutionId) => ({plan, institutionId}),
    (plan, institutionId) => ({plan, institutionId}),
);

export const {
    action: updatePlan,
    success: updatePlanSuccess,
    failed: updatePlanFailed,
} = createAction(
    `${domain}/UPDATE_PLAN`,
    (plan, institutionId, oldPlanId) => ({plan, institutionId, oldPlanId}),
    (plan, institutionId) => ({plan, institutionId}),
);

export const {
    action: deletePlan,
    success: deletePlanSuccess,
    failed: deletePlanFailed,
    aborted: deletePlanAborted,
} = createAction(`${domain}/DELETE`, (planId, childId, institutionId) => ({planId, childId, institutionId}));

export const {action: planPeriodDidChange} = createAction(`${domain}/PERIOD_CHANGE`, (validOn, validTo) => ({
    validOn,
    validTo,
}));

export const {action: packageDidChange} = createAction(
    `${domain}/PACKAGE_CHANGE`,
    (planPartId, planPackage, session, oldPackage) => ({planPartId, planPackage, session, oldPackage}),
);

export const {action: packagesDidChange} = createAction(`${domain}/PACKAGES_CHANGE`, (planPartId, packages) => ({
    planPartId,
    packages,
}));

export const {action: pricingGroupDidChange} = createAction(`${domain}/PRICING_GROUP_CHANGE`, pricingGroupId => ({
    pricingGroupId,
}));

export const {action: setBillingProfile} = createAction(
    `${domain}/SET_BILLING_PROFILE`,
    (planPartId, billingProfile, override) => ({planPartId, billingProfile, override}),
);

export const {action: openBillingProfileModal} = createAction(`${domain}/OPEN_BILLING_PROFILE_MODAL`, planPartId => ({
    planPartId,
}));

export const {action: closeBillingProfileModal} = createAction(`${domain}/CLOSE_BILLING_PROFILE_MODAL`, () => ({}));
